// extracted by mini-css-extract-plugin
export default {"mCard":"GE-z","image":"HE-z","imageNoBackground":"IE-z","imageHasCategory":"JE-z","fullWidth":"KE-z"};